import React from 'react';
import styled from 'styled-components';
import { SiteConfig } from '@99designs/site-navigation/lib/Site';
import Columns, { Column } from '../../../../shared/components/Columns';
import Link from '../../../../shared/components/Link';
import { support } from '../../../../shared/lib/platformUrls';
import { media } from '../../../../shared/lib/styles';
import { NarrowContact } from '../../Contact';
import FAQSection from './FAQSection';
import { Question } from './FAQSection';

const contactFeatureColor = '#952F38';

const StyledColumn = styled(Column)`
    margin-top: 180px;
    @media ${media('small', 'medium')} {
        margin-top: 0;
    }
`;

interface Props {
    categoryKey: string;
    faqDescription: string;
    faqQuestions: Question[];
    siteConfig: SiteConfig;
}

function SupportSection({ categoryKey, faqDescription, faqQuestions, siteConfig }: Props) {
    return (
        <Columns>
            <Column width={[12, 12, 6, 6]}>
                <FAQSection
                    categoryKey={categoryKey}
                    description={faqDescription}
                    questions={faqQuestions}
                />
            </Column>
            <StyledColumn id="contact" width={[12, 12, 6, 6]}>
                <NarrowContact
                    description={
                        <>
                            {`${__(
                                'Our kind, happy and humble customer support team would love to answer your questions.'
                            )} `}
                            <Link href={support.newSupportRequest(siteConfig.locale)}>
                                {__('Send us an email')}
                            </Link>
                            {` ${__('or call to speak with an actual human.')}`}
                        </>
                    }
                    heading={__("Let's talk!")}
                    supportPhoneNumber={siteConfig['phone.support']}
                    featureColor={contactFeatureColor}
                />
            </StyledColumn>
        </Columns>
    );
}

export default SupportSection;
